module.exports = __webpack_public_path__ + "static/media/level.5df4cb48.svg";